import { render, staticRenderFns } from "./DepUrology.vue?vue&type=template&id=6f8e9d6e&scoped=true&"
import script from "./DepUrology.vue?vue&type=script&lang=js&"
export * from "./DepUrology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8e9d6e",
  null
  
)

export default component.exports